/**
 * Enabled by default when the REST API URL is configured.
 * Set NEXT_PUBLIC_API_HEALTH_GATE_ENABLED=false to disable (e.g. local dev).
 */
export function isApiHealthGateEnabled(): boolean {
  if (process.env.NEXT_PUBLIC_API_HEALTH_GATE_ENABLED === 'false') {
    return false;
  }

  return Boolean(process.env.NEXT_PUBLIC_REST_API_ENDPOINT?.trim());
}
